import React, { useState, useEffect, Fragment, useContext, useRef, useCallback } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Button, Modal, Spin, Statistic } from 'antd'
import Router from 'next/router'
import NodeRSA from 'node-rsa'
import { resCodeMsg } from '@/components/resCodeMsg';
import QrCode from 'qrcode.react'
import Base64 from 'base-64'
import Image from 'next/image'
import { initialQuery, checkoutPayment } from '@/components/H5PC/service'
import { CommonError } from '@/components/H5PC/CommonMethod.js'
import { localStorage, reportEventToMonitor } from '@/utils'

import { paymentPayflow, paymentJaPayflow, getInitCardInfo } from '@/components/H5PC/service';



import {
    CommonHandleSubmit,
    CommonHandleCancelPayment,
    CommonJudgePaymentStatus,
    CommonTestCode,
} from '@/components/H5PC/CommonMethod';


const { Countdown } = Statistic

import myContext from '@/utils/createContext'

const AlipayHK = props => {
    const lang = localStorage.getItem('locale')
    const { intl } = props
    const { urlParams, checkPolling, type, initData, isMobile, publicKey, key, token, orderStatus } = useContext(myContext) || {}
    // const { referrer } = urlParams
    const { formatMessage } = intl

    // 重要!!! 避免react18二次请求
    const renderRef = useRef(true)

    const [codeValid, setCodeValid] = useState(false)
    const [loading, setLoading] = useState(true)
    const [orderId, setOrderId] = useState('')
    // const [publicKey, setPublicKey] = useState('')
    const [qrTtl, setQrTtl] = useState(0)
    const [qrCode, setQrCode] = useState('')
    const [qrNonce, setQrNonce] = useState('')
    const [trueMoneyMethods, setTrueMoneyMethods] = useState([])

    useEffect(() => {
        if (publicKey && token && (orderStatus && orderStatus != 'PS')) { 
            fetchData(token, publicKey)
        }
    }, [publicKey, token, orderStatus])

    const fetchData = async (token, publicKey) => {

        let params = {}

        params = {
            terminalType: 'WEB',
            paymentType: type,
        }
        console.log(params);

        
        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')
        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey.encrypt(newParams, 'base64')
        // 加密后的参数
        payment(token, encrypt_data)
    }

    const payment = async (token, encrypt_data) => {
        setLoading(true)
        const params = {
            encrypted: encrypt_data,
            token,
        }
        const res = await paymentJaPayflow('offline', key, params);
        if (res.code === 600001 || res.code === 600002) {
            const resNext = await getInitCardInfo('cashier', key);
            const myToken = resNext && resNext.data && resNext.data.token;
            const myPublicKey = resNext && resNext.data && resNext.data.publicKey

            fetchData(myToken, myPublicKey)
        }

        if (res && res.code === 200000) {
            if (res.data.paymentStatus === 'PF') { 
                Modal.warning({
                    width: isMobile ? '80%' : '500px',
                    centered: true,
                    // content: CodeMsg(res.code),
                    content: formatMessage({ id: 'ga-checkout.error-990000'}),
                    className: isMobile ? 'h5pc-cashier-error_modal' : '',
                    // okText: 'Got It',
                    okText: formatMessage({ id: 'ga-checkout.got-it' }),
                    onOk() {
                        return new Promise((resolve, reject) => {
                            setLoading(false);
                            setTimeout(Math.random() > 0.5 ? resolve : reject, 500);
                        }).catch(() => console.log('error!'));
                    },
                });
            } else {
                setLoading(false)
                if (res.data.redirectUrl) {
                    setCodeValid(true)
                    // 获取二维码
                    setQrCode(res.data?.redirectUrl)

                    setQrTtl(res.data?.effectiveTime)

                    // 显示即轮询
                    checkPolling()
                } else { 
                    reportEventToMonitor(`alipay PC端接口出参报警(cashier_parameter_output): redirectUrl不存在; 支付结果接口url=/payment/offline/payflow/${key};`)            
                }
            }
        }

        if (res.code === 200100) {
            Modal.warning({
                width: isMobile ? '80%' : '500px',
                centered: true,
                className: isMobile ? 'h5pc-cashier-error_modal' : '',
                // content: CodeMsg(990000),
                content: formatMessage({ id: 'ga-checkout.error-200100' }),
                // okText: 'Got It',
                okText: formatMessage({ id: 'ga-checkout.got-it' }),
                onOk() {
                    return new Promise((resolve, reject) => {
                        setLoading(false);
                        window.location.href = '/success?errorCode=200100'
                    }).catch(() => console.log('error!'));
                },
            });
        }
    }

    const onCountdownFinish = () => {
        setCodeValid(false)
        setQrTtl(0)
    }

    // 重新获取二维码
    const refreshCode = () => {
        // const methods = payMethods.filter(x => x.indexOf('_TM') > -1)
        const params = {
            terminalType: 'WEB',
            paymentType: type,
        }
        const pubKey = new NodeRSA(publicKey, 'pkcs8-public')
        // 必须得加，要和java加密解密统一
        pubKey.setOptions({ encryptionScheme: 'pkcs1' })
        const newParams = JSON.stringify(params)
        const encrypt_data = pubKey.encrypt(newParams, 'base64')

        payment(token, encrypt_data)
    }

    const renderText = () => {
        let _width = 94;
        switch (type) {
            case 'alipay_cn':
                _width = 80;
                break;
            case 'tng':
                _width = 20;
                break;
            case 'kakaopay':
                _width = 50;
                break;
            case 'gcash':
                _width = 85;
                break;
            case 'boost':
                _width = 66;
                break;
            default:
                _width = 94;
        }
       const _html = <>
           <span style={{ marginRight: 5, verticalAlign: 'super' }}>
               <FormattedMessage id={`alipay+.${type}.pc.tip`} />
           </span>
           {/* 兼容线上图片文件名大小写 */}
           <span>
               <Image
                src={`/static/images/alipay/${type==='gcash'?'GCash':type}.svg`}
                alt={ type}
                width={_width}
                height={20}
               />
            </span>
        </>
        return _html
    }

    const deadline = Date.now() + qrTtl * 1000

    return (
        <Fragment>
            <div className="qr">
                <div className="qr-code">
                    <div className="qr-code-title">

                        {renderText()}

                    </div>
                    {loading ? (
                        <Spin size="medium"></Spin>
                    ) : (
                        <Fragment>
                            <div className="qr-code-img">
                                {codeValid ? (
                                    <div className="qr-code-img-valid">
                                        <QrCode value={qrCode} size={200} id="truemoney code" />
                                        <div className="qr-code-countdown">
                                            {
                                                lang === 'zh-CN' || lang === 'zh-TW' || lang === 'ja-JP' ?
                                                    <>
                                                        <FormattedMessage id="thai-qr.countdown-before" />
                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                    </>
                                                    :
                                                    <>
                                                        <FormattedMessage id="thai-qr.countdown" />
                                                        <Countdown value={deadline} onFinish={onCountdownFinish} />
                                                        <FormattedMessage id="thai-qr.countdown-mins" />
                                                    </>
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <div className="qr-code-img-invalid" onClick={refreshCode}>
                                        <Image src="/static/images/shixiao@3x.png" alt="invalid" width={230} height={250} />
                                        <div className="qr-code-img-invalid-refresh">
                                            <Image src="/static/images/shuaxin@2x.png" alt="invalid" width={18} height={18} />
                                            <br />
                                            <Button type="link">
                                                <FormattedMessage id="thai-qr.refresh" />
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
        </Fragment>
    )
}

export default injectIntl(AlipayHK)
